export class SourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "mongoAtlas",
            "baseName": "mongoAtlas",
            "type": "MongoAtlasSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspaceSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "Microsoft365SourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "entraId",
            "baseName": "entraId",
            "type": "EntraIdSourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "claudeEnterprise",
            "baseName": "claudeEnterprise",
            "type": "ClaudeEnterpriseSourceAccountAttributesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
